<div class="sidebar d-none d-lg-flex align-content-between flex-wrap" [class.sidebar-open]="isOpen">
  <div style="width: 100%;">
    <div>
      <a class="hide-navigation" aria-label="Skrij navigacijo">
        <i class="fa fa-thumb-tack"></i>
      </a>
    </div>
    <div class="sidebar-header">
      <!-- Mobile: uvek prikaži tekst kada je sidebar otvoren -->
      <!-- Desktop: prikaži tekst samo na lg+ ekranima -->
      <h5 class="app-name mt-3 mb-1 mb-lg-3 text-center" [class.d-none]="!isOpen" [class.d-lg-block]="!isOpen">
        IZA
      </h5>
      <div class="d-lg-none app-name text-center fas fa-user" style="font-size: smaller;">
        <span class="ml-2"></span>
      </div>
    </div>
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link d-flex align-items-center py-2" routerLink="/chat">
          <i class="fas fa-comment-dots me-2"></i>
          <!-- Mobile: prikaži tekst kada je sidebar otvoren -->
          <!-- Desktop: prikaži tekst samo na lg+ ekranima -->
          <span [class.d-none]="!isOpen" [class.d-lg-inline]="!isOpen" [class.d-inline]="isOpen"
                style="font-size: 1rem;">
                        Pogovor z Izo
                    </span>
        </a>
      </li>
      <li class="nav-item d-lg-none">
        <a class="nav-link d-flex align-items-center py-2" href="/mojszz">
          <i class="fas fa-home me-2"></i>
          Moj SZZ
        </a>
      </li>
      <div class="mr-lg-2 docs-design">
        <li class="nav-item d-lg-none">
          <a class="nav-link d-flex align-items-center py-2" (click)="onLogout()">
            <i class="fas fa-sign-out-alt me-2"></i>
            Odjava
          </a>
        </li>
      </div>
    </ul>
  </div>
</div>
